import { Component, OnInit, Input, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { SemTextInputComponent } from '../sem-text-input/sem-text-input.component';
import { MinLengthValidator, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ValueAccessorBase } from '../shared/value-accessor/value-accessor-base';

@Component({
  selector: 'sem-text-box',
  templateUrl: './sem-text-box.component.html',
  styleUrls: ['./sem-text-box.component.css'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: SemTextBoxComponent, multi: true }
  ]
})

export class SemTextBoxComponent extends ValueAccessorBase<string> implements OnInit {

  @Input() fields: any;
  @Input() isNumberInput: boolean = false;
  @Input() isPasswordInput: boolean = false;
  @Input() showTooltipValue: any;
  disResults: any[] = [];
  @Input() isActiveUrl: boolean = false;
  @Input() step: string = "1";
  @Input() maxLength: string = "";
  @Input() isIntegerInput: boolean = false;
  @Input() isAlphaInput: boolean = false;
  @Input() isCurrencyInput: boolean = false;
  @Input() currencySign: string = '';
  @Input() hiddenValueCondition: string;
  @Input() retryBindingProp: string;
  isHiddenValue: boolean = false;

  @ViewChild("numInput") numInput: ElementRef;
  @ViewChild("alphaInput") alphaInput: ElementRef;
  @ViewChild("intInput") intInput: ElementRef;
  maxLengthInteger: number = 1000; //default value

  addResult() {
    this.disResults.push(this.checkForDisabled(this.getAttribute('name')));
  }

  super() { }

  ngOnInit() {

    if (this.isIntegerInput) {
      this.isPasswordInput = false;
      this.isNumberInput = false;
    }

    super.ngOnInit();

    this.isHiddenValue = false;
    if (this.hiddenValueCondition != null && typeof this.hiddenValueCondition != "undefined" && this.hiddenValueCondition.length > 0) {
      this.isHiddenValue = eval(this.hiddenValueCondition);
    }

    /*if (this.isNumberInput == null || typeof this.isNumberInput == "undefined") {
      this.isNumberInput = false;
    } else {
      this.restProviderService.modelValueChanged.subscribe(model => {

        if (this.model != null && typeof this.model != "undefined" && Object.keys(model).length > 3) {
          let bp = this.getAttribute('name').replace("model.", "");

          let v = this.dfms.getValue(this.model, bp);
          
          if (v) {
            this.value = v.toLocaleString("sl-SI");
          }

        }

      });
    }*/

    if (this.showTooltipValue == null || typeof this.showTooltipValue == "undefined") {
      this.showTooltipValue = false;
    }

    try {
      if (this.maxLength && this.maxLength.length > 0) {
        this.maxLengthInteger = parseInt(this.maxLength.trim());
      }
    } catch {

    }

  }

  protected override valueChanged(): void {

    // Skip locale formatting when maxLength is set — toLocaleString adds thousand separators
    // which inflate the character count and cause maxlength truncation at the wrong position.
    if (!isNaN(Number(this.value)) && this.isNumberInput && !this.maxLength) {
      let v: number = Number(this.value);
      //TODO: Bad idea.... But until we refactor this with additional settings...
      this.value = v.toLocaleString("sl-SI").replace(".", "").replace("−","-");
    }

  }

  redirectToActiveUrl(value) {
    if (value != null && typeof value != "undefined" && value.length > 0) {
      window.open(value, "_blank");
    }
  }

  onRevealHiddenValue() {    
    this.isHiddenValue = false;        
    this.dfms.assign(this.model, this.retryBindingProp, true, true);    
  }

  onTextChange(value) {

    if (this.isNumberInput) {
      var isValid = /^[0-9,.]*$/.test(value);
      if (!isValid) {
        value = "";
        this.value = "";
        this.dfms.assign(this.model, this.bindingProperty, "", true);
        if (this.numInput && this.numInput.nativeElement) {
          this.numInput.nativeElement.value = ""
        }
      }
    }

    if (this.isIntegerInput) {
      var isValid = /^\+?[0-9]*$/.test(value);
      if (!isValid) {
        value = value.replace(/[^0-9+]/g, '').replace(/(?!^)\+/g, '');
        this.value = value;
        this.dfms.assign(this.model, this.bindingProperty, value, true);
        if (this.intInput && this.intInput.nativeElement) {
          this.intInput.nativeElement.value = value;
        }
      }
    }

    if (this.isAlphaInput) {
      // Covers A-Z, Latin-1 Supplement and Latin Extended-A/B (excludes × U+00D7 and ÷ U+00F7)
      var isValid = /^[a-zA-ZÀ-ÖØ-öø-ɏ]*$/.test(value);
      if (!isValid) {
        value = value.replace(/[^a-zA-ZÀ-ÖØ-öø-ɏ]/g, '');
        this.value = value;
        this.dfms.assign(this.model, this.bindingProperty, value, true);
        if (this.alphaInput && this.alphaInput.nativeElement) {
          this.alphaInput.nativeElement.value = value;
        }
      }
    }

    let numberValue = parseFloat(value);

    if (!isNaN(this.min)) {
      let minNumber = parseFloat(this.min);
      if (numberValue < minNumber) {
        this.value = null;
        this.changeDetection.detectChanges();
        this.value = minNumber.toString();
        return;
      }
    }

    if (!isNaN(this.max)) {
      let maxNumber = parseFloat(this.max);
      if (numberValue > maxNumber) {
        this.value = null;
        this.changeDetection.detectChanges();
        this.value = maxNumber.toString();
        return;
      }
    }


    this.checkAfterInput(value);
  }

  checkAfterInput(value) {
    let attName = this.getAttribute("name");

    let control = this.dfms.globalForm.controls[attName];

    if (control !== null && typeof control !== "undefined") {
      this.dfms.globalForm.controls[attName].setValue(value);
      this.dfms.globalForm.controls[attName].updateValueAndValidity();
    }


    this.dfms.updateControlsValidationArray(attName, value);

    if (typeof this.onValueChangeEval != "undefined" && this.onValueChangeEval) {
      // Check if the string starts and ends with double quotes and remove them
      if (this.onValueChangeEval.startsWith('"') && this.onValueChangeEval.endsWith('"')) {
        this.onValueChangeEval = this.onValueChangeEval.substring(1, this.onValueChangeEval.length - 1);
      }
      eval(this.onValueChangeEval);
    }
  }

}
